import React, { useEffect, useState } from "react";
import SideMenuHOD from "../components/SideMenuHOD";
import Header from "../components/Header";
import Footer from "../components/Footer";
import usercreation from "../assets/images/usercreation.png";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  InputAdornment,
  Tooltip,
  IconButton,
} from "@mui/material";
import API_BASE_URL from "../utilities/ApiConfig";
import { useSelector } from "react-redux";

const UserCreation = () => {
  const [districts, setDistricts] = useState([]);
  const [sros, setSros] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const { userDetails } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    dcode: "",
    srocode: "",
    username: "",
    createdByUserId: userDetails.user_id,
    levelId: "s",
    thumb: "Rk1SACAyMAAAAAE4AAABLAGQAMUAxQEAAAA7L0BoAIP+AIAoAJyUAEC/A",
    email: "",
    mobileNo: "",
    password: "123",
    userRole: "",
    userDesig: "",
  });
  const fetchMasterData = async () => {
    try {
      const [districtRes, designationRes, roleRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/Master/get_District_Mas`),
        axios.get(`${API_BASE_URL}/Master/get_Designation_Mas`),
        axios.get(`${API_BASE_URL}/Master/get_Role_Mas`),
      ]);

      setDistricts(districtRes.data.data);
      setDesignations(designationRes.data.data);
      setRoles(roleRes.data.data);
    } catch (error) {
      console.error("Error fetching master data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMasterData();
  }, []);

  // Fetch SRO data based on selected district (dcode)
  const fetchSroData = async (dcode) => {
    if (!dcode) return;

    try {
      const response = await axios.get(
        `${API_BASE_URL}/Master/get_sro_master_data?dcode=${dcode}`
      );
      setSros(response.data.data);
    } catch (error) {
      console.error("Error fetching SRO data:", error);
    }
  };

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });

    // If district is changed, fetch corresponding SROs
    if (name === "dcode") {
      fetchSroData(value);
      setFormData((prevData) => ({ ...prevData, srocode: "" })); // Reset SRO selection
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    debugger;
    e.preventDefault();

    try {
      const response = await axios.post(
        `${API_BASE_URL}/Auth/create_new_user`,
        formData
      );

      console.log("User Created Successfully:", response.data.status);
      alert(response.data.status);
      setFormData({
        dcode: "",
        srocode: "",
        username: "",

        levelId: "S",
        thumb: "Rk1SACAyMAAAAAE4AAABLAGQAMUAxQEAAAA7L0BoAIP+AIAoAJyUAEC/A",
        email: "",
        mobileNo: "",
        password: "123",
        userRole: "",
        userDesig: "",
      });
    } catch (error) {
      console.error("Error creating user:", error);
      alert("Failed to create user.");
    }
  };

  return (
    <div className="flex flex-row h-screen">
      <SideMenuHOD className="w-full md:w-64" />
      <div className="flex-1 flex flex-col overflow-hidden">
        <div className="shadow-sm">
          <Header />
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          <div className="flex flex-col md:flex-row items-center justify-between p-4 md:p-10 bg-white">
            {/* Form Section */}
            <form className="w-full md:w-1/2" onSubmit={handleSubmit}>
              <h2 className="text-xl font-semibold">User Creation</h2>
              <p className="text-gray-500 mb-4">
                Create New User For Your District’s Sub-Registrar Office
              </p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* District Dropdown */}
                <TextField
                  select
                  name="dcode"
                  label="Select District"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={formData.dcode}
                  onChange={handleChange}
                  required
                >
                  {districts.map((district) => (
                    <MenuItem key={district.dcode} value={district.dcode}>
                      {district.districtName}
                    </MenuItem>
                  ))}
                </TextField>

                {/* SRO Dropdown (Populated based on selected District) */}
                <div className="relative">
                  <TextField
                    select
                    name="srocode"
                    label="Select SRO"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formData.srocode}
                    onChange={handleChange}
                    required
                    disabled={!formData.dcode}
                  >
                    {sros.map((sro) => (
                      <MenuItem key={sro.srocode} value={sro.srocode}>
                        {sro.sroname}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
                <TextField
                  label="Full Name"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  required
                />
                <TextField
                  label="Mobile No"
                  name="mobileNo"
                  value={formData.mobileNo}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  required
                />
                <TextField
                  label="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                  required
                />

                {/* Designation Dropdown */}
                <TextField
                  select
                  name="userDesig"
                  label="Select Designation"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={formData.userDesig}
                  onChange={handleChange}
                  required
                >
                  {designations.map((designation) => (
                    <MenuItem
                      key={designation.designationId}
                      value={designation.designationName}
                    >
                      {designation.designationName}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  select
                  name="userRole"
                  label="Select Role"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={formData.userRole}
                  onChange={handleChange}
                  required
                >
                  {roles.map((role) => (
                    <MenuItem key={role.roleId} value={role.roleName}>
                      {role.roleName}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              <button
                type="submit"
                className="w-full bg-blue-500 text-white mt-4 py-2 rounded-lg hover:bg-blue-600 transition"
              >
                Create User
              </button>
            </form>

            {/* Image Section */}
            <div className="w-full md:w-1/2 flex justify-center mt-6 md:mt-0">
              <img
                src={usercreation}
                alt="User Creation Illustration"
                className="w-48 md:w-64"
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-0 bg-blue-100 text-center">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default UserCreation;
